import { Dictionary } from "flow/api/types";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import ko from "knockout";
import viewHtml from "./textareaInput.html";

export interface ITextAreaInputParams {
    value: KnockoutObservable<string>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    preventBubble?: string;
    attr?: MaybeObservableAttributes;
    style?: Dictionary<MaybeObservable<any>>;
    resizeable?: boolean;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    metaPlaceholder?: MaybeObservable<string>;
    placeholder?: MaybeObservable<string>;
    autogrow?: boolean;
}

ko.components.register("ko-textareainput", {
    viewModel: function (params: ITextAreaInputParams) {
        this.value = params.value;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_textareainput", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
        this.preventBubble = params.preventBubble || "";

        this.style = ko.utils.extend(
            {
                resize: !!params.resizeable ? "both" : "none"
            },
            ko.utils.unwrapObservable(params.style)
        );

        this.autogrow = !!params.autogrow;
    },
    template: viewHtml,
    synchronous: true
});
